app.service('productVariants', function(modal) {
	let modals = [];

	function openModal({ code, header, content }) {
		if (modals[code]) {
			return modals[code].open();
		}

		modals[code] = modal.generate({
			header,
			content,
			modifier: 'remodal-full-width'
		});
	}

	function logEvent($element) {
		const data = ($element.data('event') || '').split('|');

		if (data.length === 6) {
			UA.pageInteraction(
				'Wariantowanie - ' + data[5],
				$.trim($element.attr('title'))
			);

			app.logEvent({
				id: 'wariantowanie',
				f03: data[0],
				f04: data[1],
				f05: data[2],
				f06: data[3],
				f07: data[4]
			});
		}
	}

	function handleVariantItemClick() {
		const $element = $(this);

		logEvent($element);

		$element
			.addClass('active-item')
			.siblings()
			.removeClass('active-item');
	}

	function handleOpenModalClick() {
		const $element = $(this);
		const code = $element.attr('data-code');
		const attribute = $element.attr('data-attribute');
		const content = $element.find('.variant-list').clone();
		const header = `Warianty - ${attribute}`;

		openModal({ code, header, content });
	}

	function setEvents() {
		$('body')
			.on('click', '.js-variant', handleOpenModalClick)
			.on('click', '.js-variant-item', handleVariantItemClick);
	}

	function init() {
		setEvents();
	}

	return {
		init: init
	};
});
